<template>
  <span class="w-24 h-10 bg-gray-200 rounded animate-pulse" />
</template>
